import React, { Component } from 'react';

function checkForAuth() {
  const storageData = localStorage.getItem('data');
  if (storageData !== null) {
    const data = JSON.parse(storageData);
    if (data.user_company_code) {
      return true;
    }
    return false;
  }
}

function checkForData() {
  const storageData = localStorage.getItem('data');
  if (storageData !== null) {
    const data = JSON.parse(storageData);
    if (data.user_company_code) {
      return data;
    }
    return undefined;
  }
}

const Authentication = (WrappedComponent) => {
  class WithAuthentication extends Component {
    constructor() {
      super();
      this.state = {
        isAuthenticated: checkForAuth(),
        userData: checkForData(),
      };
      this.setAuthentication = this.setAuthentication.bind(this);
    }

    setAuthentication(state, data, callback) {
      this.setState({ isAuthenticated: state, userData: data }, callback);
    }

    render() {
      return <WrappedComponent isAuthenticated={this.state.isAuthenticated} loggedInFlag={this.state.isAuthenticated} setAuthentication={this.setAuthentication} userData={this.state.userData} />
    }
  }
  return WithAuthentication;
};

export default Authentication;



// WEBPACK FOOTER //
// ./src/Components/Authentication/Authentication.jsx